import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Form, Input, Button, Alert, message, Select, Row, Col, InputNumber, DatePicker, Switch, Upload } from 'antd';
import Ink from 'react-ink';
import {  isEmpty } from 'ramda';
import dayjs from 'dayjs';
import countriesInfo from '../../../config/countriesInfo.json';

import { advertisementPackageUpdate, advertisementPackageCreate, advertisementGetPackage, advertisementGetOrder, advertisementOrderUpdate, advertisementOrderCreate, advertisementUpload } from '../../../modules/advertisement';

import { CheckCircleOutlined, ArrowRightOutlined, UploadOutlined } from '@ant-design/icons';

import moment from 'moment';

 const { Option } = Select;
 const FormItem = Form.Item;
const { RangePicker } = DatePicker;

class AddPackage extends Component {
	formRef = React.createRef();
	constructor(props) {
		super(props);
		this.state = {
			loading: false,
			message: null,
      fileList: [],
      uploadType: 'image',
      previewImage: '',
      previewOpen: false,
      previewTitle: '',
		}
	}

  getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

  handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await this.getBase64(file.originFileObj);
    }
    this.setState({
      previewImage: file.url || file.preview,
      previewOpen: true,
      previewTitle: file.name || file.url.substring(file.url.lastIndexOf('/') + 1),
    });
  };

	handleSubmit = async (values, modalFrom) => {
    const { selected, modalType } = this.props;
		this.setState({ loading: true, message: null });

    if (modalFrom === 'Package') {
      let new_values = {...values};
      new_values.startDate = new_values.dateRange[0].toISOString();
      new_values.endDate = new_values.dateRange[1].toISOString();
      new_values.day = new_values.day.map(d => typeof d === "string" ? d : d.value);
      new_values.time = new_values.time.map(t => typeof t === "string" ? t : t.value);
      delete new_values.dateRange;
      if (selected && selected._id && modalType === 'edit') {
        this.props.advertisementPackageUpdate(new_values, selected._id).then(
          (res) => {
            message.success('Package successfully updated!');
            this.setState({ loading: false, message: null });
            if (this.formRef.current) { this.formRef.current.resetFields(); }
            this.onClose(modalFrom);
          },
          (err) => {
            this.setState({ loading: false, message: err.message||err });
          }
        );
      } else {
        this.props.advertisementPackageCreate(new_values).then(
          (res) => {
            message.success('Package successfully added!');
            this.setState({ loading: false, message: null });
            if (this.formRef.current) { this.formRef.current.resetFields(); }
            this.onClose(modalFrom);
          },
          (err) => {
            this.setState({ loading: false, message: err.message||err });
          }
        );
      }
    }else{
      let newValues = {...values};
      let fileList = values.asset && values.asset.fileList;
      if (!isEmpty(fileList) && typeof fileList === 'object') {
        if(fileList.length === 1 && fileList[0].originFileObj){
          newValues.format = fileList[0].type.includes('image') ? 'image' : 'video';
          let data;
          try {
            data = await this.props.advertisementUpload(fileList[0].originFileObj, newValues.format);
          } catch (error) {
            this.setState({ loading: false, message: 'There is something wrong with this asset, please replace it and try again.' });
            return;
          }
          newValues.asset = data.url;
        }else{
          newValues.asset = fileList[0].url;
        }
      }else if(isEmpty(fileList)){
        this.setState({ loading: false, message: 'Asset is required' });
        return;
      }
      if (newValues.free) {
        newValues.budget = 0;
      }
      if (newValues.tag && newValues.tag.length) {
        newValues.tag = newValues.tag.map(t => t.toLowerCase());
      }


      if (selected && selected._id && modalType === 'edit') {
        this.props.advertisementOrderUpdate(newValues, selected._id).then(
          (res) => {
            message.success('Order successfully updated!');
            this.setState({ loading: false, message: null });
            if (this.formRef.current) { this.formRef.current.resetFields(); }
            this.onClose(modalFrom);
          },
          (err) => {
            this.setState({ loading: false, message: err.message||err });
          }
        );
      } else {
        this.props.advertisementOrderCreate(newValues).then(
          (res) => {
            message.success('Order successfully added!');
            this.setState({ loading: false, message: null });
            if (this.formRef.current) { this.formRef.current.resetFields(); }
            this.onClose(modalFrom);
          },
          (err) => {
            this.setState({ loading: false, message: err.message||err });
          }
        );
      }
    }
	}

	onClose(modalFrom) {
		this.setState({
			message: null,
      fileList: [],
      uploadType: 'image',
      previewImage: '',
      previewOpen: false,
      previewTitle: '',
		});
		if (this.formRef.current) { this.formRef.current.resetFields(); }
    if (modalFrom === 'Package') {
      this.props.advertisementGetPackage();
    }else{
      this.props.advertisementGetOrder();
    }
		this.props.toggleModal();
	}

	render() {
    const { showModal, selected, modalType, modalFrom, advertisementPackageList, defaultPackage } = this.props;
		const { loading, message, previewOpen, previewImage, previewTitle } = this.state;
    const packageList = advertisementPackageList || [];

		const formItemLayout = {
			labelCol: { span: 6 },
			wrapperCol: { span: 18 },
		};

    const getDayLabel = (i) => {
      return (
        i === 0 ? 'Sun' :
        i === 1 ? 'Mon' :
        i === 2 ? 'Tue' :
        i === 3 ? 'Wed' :
        i === 4 ? 'Thu' :
        i === 5 ? 'Fri' :
        'Sat'
      )
    }

    const initialValues = modalType === 'add' ?
      modalFrom === 'Package' ?
      {cpm: 0} : {inventory: 0, budget: 1, package: defaultPackage, format: "image", free: false, asset: {fileList: []}} :
      modalFrom === 'Package' ?
      {
        title: (selected && selected.title) ? selected.title : "",
        description: (selected && selected.description ) ? selected.description : '',
        cpm: (selected && selected.cpm ) ? selected.cpm : 0,
        time: ( selected && selected.time ) ? selected.time.map(i =>{return {value: `${i}`, label: `${i.toString().padStart(2, '0')}:00`}}) : undefined,
        day: ( selected && selected.day ) ? selected.day.map(i =>{return {value: `${i}`, label: getDayLabel(i)}}) : undefined,
        region: (selected && selected.region ) ? selected.region : 'World',
        startDate: (selected && selected.startDate ) ? moment(selected.startDate).utc() : '',
        endDate: (selected && selected.endDate ) ? moment(selected.endDate).utc() : '',
        dateRange: (selected && selected.startDate && selected.endDate ) ? [dayjs(selected.startDate), dayjs(selected.endDate)] : [],
        placement: (selected && selected.placement ) ? selected.placement : ''
      }
      :
      {
        free: (selected && selected.free) ? selected.free : false,
        name: (selected && selected.name ) ? selected.name : null,
        contact: (selected && selected.contact ) ? selected.contact : '',
        package: ( selected && selected.package ) ? selected.package : undefined,
        tag: ( selected && selected.tag ) ? selected.tag : undefined,
        inventory: ( selected && selected.inventory ) ? selected.inventory : 0,
        budget: (selected && selected.budget ) ? selected.budget : 1,
        format: (selected && selected.format ) ? selected.format : null,
        assetId: (selected && selected.assetId ) ? selected.assetId : null,
        asset: (selected && selected.asset ) ? {fileList: [{
          uid: '-1',
          name: 'file',
          status: 'done',
          url: selected.asset,
        }]} : '',
        url: (selected && selected.url ) ? selected.url : '',
      }
      ;
		if (this.formRef.current && !loading) {
			this.formRef.current.setFieldsValue(initialValues);
		}

    const timeRangeOptions = [];
    for (let i = 0; i < 24; i++) {
      const timeValue = `${i}`;
      timeRangeOptions.push({
        label: `${i.toString().padStart(2, '0')}:00`,
        value: timeValue,
      });
    }


    const dayRangeOptions = [];
    for (let i = 0; i < 7; i++) {
      dayRangeOptions.push({
        label: getDayLabel(i),
        value: `${i}`,
      });
    }

    const locationRangeOptions = countriesInfo.map(c => {return {label: `${c.name} (${c.code})`, value: c.code}});

    var packageRangeOptions = [];
    packageList.forEach((item) => {
      packageRangeOptions.push({
          label: `${item.description} (${item.packageId})`,
          value: item.packageId,
        });
    });

    var tagOptions = ['vivamax', 'vivaone'];
    tagOptions = tagOptions.map(tag => {
      return {
        label: tag,
        value: tag,
      }
    })

		return (
			<Modal
				width={720}
				title={selected && selected._id && modalType === 'edit' ? <span><CheckCircleOutlined />{` Update ${selected.packageId || selected.assetId} ${modalFrom}`}</span> : <span><CheckCircleOutlined />{` Create ${modalFrom}`}</span>}
				open={showModal}
				onCancel={() => this.onClose(modalFrom)}
				footer={[
					<Button key="submit" form="myForm" type="primary" htmlType="submit" disabled={loading} ><Ink /><ArrowRightOutlined /> Submit</Button>,
					<Button key="back" onClick={() => this.onClose(modalFrom)} disabled={loading}>Cancel</Button>
				]}
				maskClosable={false}
				closable={(loading) ? false : true}
        destroyOnClose
				>
        {
        modalFrom === "Package" ?
          <Form ref={this.formRef} name="myForm" onFinish={(values) => this.handleSubmit(values,modalFrom)} initialValues={initialValues}>
            {(message) ? <Alert message={message} type="error" showIcon /> : ""}
            <Row>
            <Col span={24} >
              <FormItem  {...formItemLayout} label="Title" name="title" rules={[{ required: true, message: 'Please input the package title' }]}>
                <Input placeholder="Please input the package title" />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Description" name="description" rules={[{ required: true, message: 'Please input description of the package' }]}>
                <Input.TextArea placeholder="Please input description of the package" />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="CPM" name="cpm" rules={[{ required: true, type: 'number', min: 0, message: 'Please input the CPM' }]}>
                <InputNumber style={{ width: '200px' }} placeholder="Please input the CPM" />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Time Range" name="time" rules={[{ required: true, message: 'Please input the package Time Range' }]}  >
                <Select
                  mode="multiple"
                  placeholder="Please select time range"
                  options={timeRangeOptions}
                  allowClear={true}
                />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Day Range" name="day" rules={[{ required: true, message: 'Please input the package Day Range' }]}  >
                <Select
                  mode="multiple"
                  placeholder="Please select day range"
                  options={dayRangeOptions}
                  allowClear={true}
                />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Location Range" name="region" rules={[{ required: true, message: 'Please input the package Location Range' }]}  >
                <Select
                  mode="multiple"
                  placeholder="Please select location range"
                  options={locationRangeOptions}
                  allowClear={true}
                />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Date Range" name="dateRange" rules={[{ required: true, message: 'Please input the package date range' }]}>
                <RangePicker style={{width:250}}  format={'YYYY-MM-DD'}/>
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem {...formItemLayout} label="Adv Placements"  name="placement" rules={[{ required: true, message: 'Please input the package placement' }]}>
                <Select>
                  <Option key='smartphone banner'>Smartphone Banner</Option>
                  <Option key='leaderboard'>Leaderboard</Option>
                  <Option key='super leaderboard'>Super Leaderboard</Option>
                  <Option key='interstitial portrait'>Interstitial Portrait</Option>
                  <Option key='interstitial landscape'>Interstitial Landscape</Option>
                  <Option key='sponsor logo'>Sponsor Logo</Option>
                  <Option key='preroll video'>Preroll Video</Option>
                  <Option key='midroll video'>Midroll Video</Option>
                </Select>
              </FormItem>
            </Col>

            </Row>
          </Form>
        :
          <Form ref={this.formRef} name="myForm" onFinish={(values) => this.handleSubmit(values, modalFrom)} initialValues={initialValues}>
            {(message) ? <Alert message={message} type="error" showIcon /> : ""}
            <Row>
            <Col span={24} >
              <FormItem {...formItemLayout} label="Free"  name="free">
                <Switch disabled={selected} />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Name" name="name" rules={[{ required: true, message: 'Please select the order name' }]}>
                <Input placeholder="Please input order name" disabled={selected} />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Contact" name="contact" rules={[{ required: true, message: 'Please input order contact' }]}>
                <Input placeholder="Please input order contact" disabled={selected} />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Package" name="package" rules={[{ required: true, message: 'Please input the order package' }]}  >
                <Select
                  options={packageRangeOptions}
                  disabled={selected}
                />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem
                noStyle
                shouldUpdate={(prevValues, currentValues) => prevValues.free !== currentValues.free}
              >
              {({ getFieldValue }) =>
                getFieldValue('free') === false ? (
                  <FormItem  {...formItemLayout} label="Budget" name="budget" rules={[{ required: true, type: 'number', min: 1, message: 'Please input the budget' }]}>
                    <InputNumber style={{ width: '200px' }} placeholder="Please input the budget" disabled={selected} />
                  </FormItem>
                ) : null
              }
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Tag" name="tag" rules={[{ required: true, message: 'Please input the order tag' }]}  >
                <Select
                  mode="tags"
                  options={tagOptions}
                  tokenSeparators={[',']}
                />
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem
                noStyle
                shouldUpdate={(prevValues, currentValues) => JSON.stringify(prevValues.asset) !== JSON.stringify(currentValues.asset)}
              >
                {({ getFieldValue }) => {
                  return (
                    <FormItem  {...formItemLayout} label="Asset" name="asset" rules={[{ required: true, message: 'Please input the asset' }]}>
                      {
                      !selected || getFieldValue('asset').fileList.length === 0 || (getFieldValue('asset').fileList[0] && getFieldValue('asset').fileList[0].status !== 'done') ?
                        <Upload
                          accept=".jpg, .jpeg, .png, .mp4"
                          multiple={false}
                          beforeUpload={(file) => {
                            return false
                          }}
                          onPreview={(file) => {
                            this.handlePreview(file)
                          }}
                          fileList={getFieldValue('asset').fileList}
                        >
                          <Button icon={<UploadOutlined />}>Upload</Button>
                        </Upload>
                        :
                        <Upload
                          accept=".jpg, .jpeg, .png, .mp4"
                          multiple={false}
                          listType="picture-card"
                          beforeUpload={(file) => {
                            return false
                          }}
                          onPreview={(file) => {
                            this.handlePreview(file)
                          }}
                          fileList={getFieldValue('asset').fileList}
                        >
                        </Upload>
                      }
                    </FormItem>
                  )
                }
                }
              </FormItem>
            </Col>

            <Col span={24} >
              <FormItem  {...formItemLayout} label="Url" name="url">
                <Input placeholder="Please input the url" />
              </FormItem>
            </Col>

            </Row>
          </Form>
        }
        <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={() => {this.setState({previewOpen: false})}}>
          <img
            alt="preview"
            style={{
              width: '100%',
            }}
            src={previewImage}
          />
        </Modal>
			</Modal>
		);
	}
}


const mapStateToProps = state => ({
	router: state.router,
  advertisementPackageList: state.advertisement.advertisementPackageList,
});

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
      advertisementPackageUpdate,
      advertisementPackageCreate,
      advertisementGetPackage,
      advertisementGetOrder,
      advertisementOrderCreate,
			advertisementOrderUpdate,
      advertisementUpload,
		},
		dispatch
	);

export default connect(mapStateToProps, mapDispatchToProps)(AddPackage);
